// extracted by mini-css-extract-plugin
export default {"subscUl":"Subscription_subscUl__kDVkR"};